import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["contextSwitcher", "renderContextSwitcher"];
import React, { memo } from "react";
import { SideNavigation } from "@jutro/router";
var AppFloorPlanLeftSideInternal = function (_ref) {
  var _ref$leftSideProps = _ref.leftSideProps,
    leftSideProps = void 0 === _ref$leftSideProps ? {} : _ref$leftSideProps,
    _ref$sideRoutes = _ref.sideRoutes,
    sideRoutes = void 0 === _ref$sideRoutes ? [] : _ref$sideRoutes,
    leftSideContextSwitcher = leftSideProps.contextSwitcher,
    renderContextSwitcher = leftSideProps.renderContextSwitcher,
    otherLeftSideProps = _objectWithoutProperties(leftSideProps, _excluded);
  return React.createElement(SideNavigation, _extends({
    routes: sideRoutes,
    contextSwitcher: leftSideContextSwitcher,
    renderContextSwitcher: renderContextSwitcher
  }, otherLeftSideProps));
};
AppFloorPlanLeftSideInternal.displayName = "AppFloorPlanLeftSide";
export var AppFloorPlanLeftSide = memo(AppFloorPlanLeftSideInternal);
AppFloorPlanLeftSideInternal.__docgenInfo = {
  description: "",
  methods: [],
  displayName: "AppFloorPlanLeftSide",
  props: {
    leftSideProps: {
      defaultValue: {
        value: "{}",
        computed: !1
      },
      required: !1
    },
    sideRoutes: {
      defaultValue: {
        value: "[]",
        computed: !1
      },
      required: !1
    }
  }
}, AppFloorPlanLeftSideInternal.__docgenInfo = {
  componentName: "AppFloorPlanLeftSide",
  packageName: "@jutro/floorplan",
  description: "",
  displayName: "AppFloorPlanLeftSide",
  methods: [],
  actualName: "AppFloorPlanLeftSideInternal",
  props: {
    leftSideProps: {
      defaultValue: {
        value: "{}",
        computed: !1
      },
      required: !1
    },
    sideRoutes: {
      defaultValue: {
        value: "[]",
        computed: !1
      },
      required: !1
    }
  }
};